import Daily from './daily';
import Weekly from './weekly';

export default {
    Daily,
    Weekly
}